var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f16-flight-left.224621d1.png","uri@2x": __webpack_public_path__ + "f16-flight-left.db404f15.png","uri@3x": __webpack_public_path__ + "f16-flight-left.83fe00d1.png",
    width: 368,
    height: 61
});